export default "__VITE_PUBLIC_ASSET__5c4158f2__"